import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

const SuccessModal = ({ show, handleShowSuccessModal }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = React.useState(show);

  const handleClose = () => {
    setOpen(false);
    handleShowSuccessModal(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.title} id="alert-dialog-title">
          {t('success', 'Success')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t('success_modal_description', 'Your response has been submitted successfully')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            {t('ok', 'OK')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

SuccessModal.propTypes = {
  show: PropTypes.bool,
  handleShowSuccessModal: PropTypes.func,
};

export default SuccessModal;
